import { render, staticRenderFns } from "./RememberPassword.vue?vue&type=template&id=b839490e&"
import script from "./RememberPassword.vue?vue&type=script&lang=js&"
export * from "./RememberPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports